import apiService from "./apiService";


export const getCarousel = (forDoctor = false) => {
  const params = {
    'type': forDoctor ? 'DOCTOR' : 'PATIENT'
  };
  return apiService.get(URIS.featured_banners, {params});
};

export const getRemoteConfigs = () => {
  return apiService.get(URIS.remote_configs);
};

export const getOnGoingCampaigns = () => {
  return apiService.get(URIS.campaigns);
};

export const getPromotionalEvents = () => {
  return apiService.get(URIS.promotional_events);
};

// const URIS_D = (url,param1) =>  {
//   return {
//     verify_otp:`/auth/confirm-otp/${param1}`,
//   }[url]
// }

const URIS = {
  featured_banners: "/v1/featured-banners",
  remote_configs: "/v1/remote-configs",
  campaigns: "/v1/campaigns",
  promotional_events: "/v1/promotional-events"
};
